import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/kwc/kwc/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Styles from '../docz-components/Styles.tsx';
import a from 'kwc/index.css';
import b from 'kwc/styles/icon-sizes.scss';
import c from 'kwc/styles/docz.global.scss';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "kwc"
    }}>{`kwc`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Components library for Konstellation projects`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/kwc"
      }}><img alt="NPM" src="https://img.shields.io/npm/v/kwc.svg" /></a>{` `}<a parentName="p" {...{
        "href": "https://standardjs.com"
      }}><img alt="JavaScript Style Guide" src="https://img.shields.io/badge/code_style-standard-brightgreen.svg" /></a></p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save kwc
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add kwc
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Add styles at the index of your website`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import 'kwc/dist/index.css';
`}</code></pre>
    <p>{`You can now import the components directly from the library`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react'

import { Button } from 'kwc'

function Example() {
  render() {
    return <Button />
  }
}
`}</code></pre>
    <h2 {...{
      "id": "docz-local-deployment"
    }}>{`Docz local deployment`}</h2>
    <p>{`In case you want to deploy the documentation site for this project you first need to install the dependencies:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn install
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install
`}</code></pre>
    <p>{`And then you can deploy the docs by executing this command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn docz dev
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm run docz dev
`}</code></pre>
    <h2 {...{
      "id": "license"
    }}>{`License`}</h2>
    <p>{`MIT © `}<a parentName="p" {...{
        "href": "https://github.com/konstellation-io"
      }}>{`konstellation-io`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      